export default __webpack_public_path__ + "static/aboutImg-1c5ef84f0dc6eea5e7c53b71ef04d501.png";